// extracted by mini-css-extract-plugin
module.exports = {"imageCard":"imageCard-module--imageCard--2_-zQ","image":"imageCard-module--image--2YRd4","imageText":"imageCard-module--imageText--2kDV2"};